export default "__VITE_ASSET__Cl0rlCGf__"